module.exports = __webpack_public_path__ + "static/logo-color-60658706706a9984fad47f33cf0d60f5.svg";